import { call, put, select } from '@redux-saga/core/effects'
import { api } from 'application/api'
import { replaceMessageQueueById, updateDataOnMessage } from 'application/redux/actions/messages'
import { setDeliveredOnOwnMessage } from '../pages/message_raw_mapper'

export function* replaceQueueMessageAkteSaga(action) {
    const { accountId, akteIdHash } = action.params
    const result = yield call(api.gateway.pages.getMessageDetails, accountId, akteIdHash)
    const deliveredMessages = setDeliveredOnOwnMessage(result.messages.timeline)
    const files = result.files
    yield put(replaceMessageQueueById(action.messageKey, action.idOnQueue, deliveredMessages[0]))
    yield put(updateDataOnMessage(action.messageKey, { files }))
}